var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isExternalLink)?_c('nuxt-link',_vm._b({attrs:{"to":_vm.link.redirect}},'nuxt-link',_vm.blankOptions,false),[_vm._v("\n        "+_vm._s(_vm.link.text)+"\n    ")]):_c('a',_vm._b({attrs:{"href":_vm.link.redirect}},'a',_vm.blankOptions,false),[_vm._v("\n        "+_vm._s(_vm.link.text)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }